import React from "../../../../__snowpack__/pkg/react.js";
export const IconSyncExpired = React.memo((props) => {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /* @__PURE__ */ React.createElement("title", null, "\u7F16\u7EC4 2"), /* @__PURE__ */ React.createElement("g", {
    id: "\u5957\u9910/\u5E97\u94FA\u63D0\u9192",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u5E97\u94FA\u5230\u671F",
    transform: "translate(-973.000000, -18.000000)"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u7F16\u7EC4-3",
    transform: "translate(973.000000, 18.000000)"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u7F16\u7EC4-2",
    transform: "translate(0.000000, 1.000000)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M8,0 C10.3831572,0 12.3606723,1.73676055 12.7359009,4.0136373 L12.8237272,4.00509269 L12.8237272,4.00509269 L13,4 C14.6568542,4 16,5.34314575 16,7 C16,8.58947186 14.7638812,9.8902327 13.2005213,9.99340473 L13.2,10 L3.2,10 L3.19909624,9.97792847 C1.39955121,9.77853994 0,8.25271132 0,6.4 C0,4.4117749 1.6117749,2.8 3.6,2.8 C3.61175272,2.8 3.62349229,2.80005632 3.63521846,2.8001687 C4.39363149,1.14758165 6.06279972,0 8,0 Z",
    id: "\u5F62\u72B6\u7ED3\u5408",
    fill: "#8C99AC"
  }), /* @__PURE__ */ React.createElement("g", {
    id: "\u7F16\u7EC4",
    transform: "translate(3.000000, 4.000000)",
    "fill-rule": "nonzero"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M5,0 C2.23857713,0 0,2.23857713 0,5 C0,7.76142287 2.23857713,10 5,10 C7.76142287,10 10,7.76142287 10,5 C10,2.23857713 7.76142287,0 5,0 Z",
    id: "\u8DEF\u5F84",
    fill: "#FF4D4F"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7.4295061,2.88844386 C7.52349797,2.98243549 7.52349797,3.13482354 7.4295061,3.22881517 L5.65831676,5 L7.4295061,6.77118485 C7.52349797,6.86517647 7.52349797,7.01756453 7.4295061,7.11155615 L7.11155517,7.42950628 C7.0175633,7.52349791 6.86517486,7.52349791 6.771183,7.42950628 L5,5.65832142 L3.228817,7.42949359 C3.13482514,7.52348522 2.9824367,7.52348522 2.88844483,7.42949359 L2.5704939,7.11154347 C2.47650203,7.01755184 2.47650203,6.86516379 2.5704939,6.77117216 L4.34168324,4.99998731 L2.57049391,3.22881515 C2.47650205,3.13482353 2.47650205,2.98243547 2.57049391,2.88844385 L2.88844484,2.57049372 C2.98243671,2.47650209 3.13482515,2.47650209 3.22881702,2.57049372 L5,4.34167857 L6.7711957,2.57049372 C6.86518756,2.47650209 7.017576,2.47650209 7.11156787,2.57049372 L7.4295061,2.88844386 Z",
    id: "\u8DEF\u5F84",
    fill: "#FFFFFF"
  })))))));
});
